import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";

const EMPTY = { id: null, title: "", body: "", image: "" };

export const AdminPosts = () => {
  const [posts, setPosts] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const load = () => api.get("/blog").then((r) => setPosts(r.data));
  useEffect(() => {
    load();
  }, []);

  const edit = async (p) => {
    const { data } = await api.get(`/blog/${p.slug}`);
    setForm({ id: data.id, title: data.title, body: data.body, image: data.image });
  };
  const save = async (e) => {
    e.preventDefault();
    const payload = { title: form.title, body: form.body, image: form.image };
    try {
      if (form.id) await api.put(`/admin/posts/${form.id}`, payload);
      else await api.post("/admin/posts", payload);
      toast.success("The teaching has been published.");
      setForm(EMPTY);
      load();
    } catch (err) {
      toast.error(formatErr(err));
    }
  };
  const remove = async (id) => {
    if (!window.confirm("Remove this post?")) return;
    await api.delete(`/admin/posts/${id}`);
    load();
  };

  return (
    <div className="grid lg:grid-cols-2 gap-8" data-testid="admin-posts">
      <form onSubmit={save} className="card-soft p-8 space-y-4">
        <h3 className="font-serif-h text-2xl">{form.id ? "Edit post" : "New post"}</h3>
        <input required placeholder="Title" className="field" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="post-title-input" />
        <input placeholder="Image URL (optional)" className="field" value={form.image} onChange={(e) => setForm({ ...form, image: e.target.value })} data-testid="post-image-input" />
        <textarea required rows={12} placeholder="Write the teaching. Leave a blank line between paragraphs." className="field" value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} data-testid="post-body-input" />
        <div className="flex gap-3">
          <button className="btn btn-olive" data-testid="post-save-btn">{form.id ? "Save Changes" : "Publish"}</button>
          {form.id && <button type="button" onClick={() => setForm(EMPTY)} className="btn btn-ghost" data-testid="post-cancel-btn">Cancel</button>}
        </div>
      </form>
      <ul className="space-y-3">
        {posts.map((p) => (
          <li key={p.id} className="card-soft p-5 flex items-center justify-between gap-4" data-testid={`admin-post-${p.slug}`}>
            <span className="font-serif-h text-xl">{p.title}</span>
            <span className="flex gap-3 text-sm shrink-0">
              <button onClick={() => edit(p)} className="text-[#577731] hover:underline" data-testid={`admin-post-edit-${p.slug}`}>Edit</button>
              <button onClick={() => remove(p.id)} className="text-[#9c3d5c] hover:underline" data-testid={`admin-post-delete-${p.slug}`}>Delete</button>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
